import { Select, Spinner } from "@king-ict/eupisi-ui/components";

import { SchoolCandidateBatchDto } from "../../../../queries";
import { SchoolCandidateBatchStatus } from "../../../../models";
import { useBatchHistory } from "./useBatchHistory";

interface IProps {
  countyId: number | undefined;
  schoolYearId: number;
  batchId: number | null;
  initialBatchStatus: SchoolCandidateBatchStatus | undefined;
  onChange: (batch: SchoolCandidateBatchDto | null) => void;
  errorText?: string;
}

export const BatchDateSelect = ({
  countyId,
  schoolYearId,
  batchId,
  initialBatchStatus,
  onChange,
  errorText,
}: IProps) => {
  const {
    selectData: processedAtSelectData,
    isFetching: isBatchHistoryFetching,
    shouldBeDisabled,
    handleOpen: handleBatchDateSelectOpen,
    handleChange: handleProcessedAtChange,
  } = useBatchHistory({
    countyId,
    schoolYearId,
    batchId,
    initialBatchStatus,
    onChange,
  });

  return (
    <div
      className="mt-3"
      onMouseDown={handleBatchDateSelectOpen}
      role="presentation"
    >
      {isBatchHistoryFetching && <Spinner show />}
      <Select
        label="Datum dohvata novih adresa"
        name="processedAt"
        value={batchId}
        onChange={handleProcessedAtChange}
        selectData={processedAtSelectData}
        disabled={shouldBeDisabled}
        required
        errorText={errorText}
      />
      {!!errorText && (
        <div className="mb-2 text-danger">
          Županija u ovoj školskoj godini nije preuzela adrese
        </div>
      )}
    </div>
  );
};
